export const doNothing: any = () => {};
export const iAmNothing: any = () => null;
